import ledger from '../../data/recruitment.json';

export type RecruitmentStatus = 'closed' | 'open' | 'scheduled';
export type RecruitmentCohort = {
  slug: string; course: 'essential' | 'advanced' | 'master'; term: string;
  startDateISO: string; endDateISO: string; applyOpenISO: string;
  applyCloseISO: string; status: RecruitmentStatus;
};
export type RecruitmentContent = {
  title: string; eyebrow: string; heroImage: string; heroAlt: string;
  figureImage: string; figureAlt: string; figureCaption: string;
  sections: { heading: string; body: string }[];
  faq: { question: string; answer: string }[];
};
export const recruitmentCohorts = ledger.cohorts as RecruitmentCohort[];
export const recruitmentSettings = ledger.settings;
const recruitmentContentModules = import.meta.glob<{ default: RecruitmentContent }>(
  './recruitmentContent/*.json',
  { eager: true },
);
export const recruitmentContent: Record<string, RecruitmentContent> = Object.fromEntries(
  Object.entries(recruitmentContentModules).map(([path, module]) => {
    const filename = path.slice(path.lastIndexOf('/') + 1);
    const slug = filename.slice(0, -'.json'.length);
    return [slug, module.default];
  }),
);
export const coursePaths = { essential: '/courses/essential', advanced: '/courses/advanced', master: '/courses/master' } as const;
